import * as React from 'react';
import type { JSX } from 'react';
import { UIHeading3 } from '@cian/ui-kit';

import * as styles from './ComparisonBanner.css';
import { NBSP } from '../../constants/symbols';

const TITLE = `Сравните ЖК с${NBSP}другими`;

export interface IComparisonBannerProps {
  compareButton: JSX.Element;
}

export const ComparisonBanner: React.FC<IComparisonBannerProps> = ({ compareButton }) => {
  return (
    <div className={styles['comparison-banner']} data-testid="ComparisonBanner">
      <div className={styles['image']} />
      <div className={styles['title']}>
        <UIHeading3>{TITLE}</UIHeading3>
      </div>
      {compareButton}
    </div>
  );
};
